import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ShieldTickOutline(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M13.3179 1.06445C12.5059 0.595703 11.4956 0.595703 10.6816 1.06445L2 6.07715V11.4678C2 15.2647 4.04297 18.8037 7.33154 20.7031L12 23.3975L16.6685 20.7031C19.957 18.8037 22 15.2646 22 11.4678V6.07715L13.3179 1.06445ZM20 11.4678C20 14.5527 18.3403 17.4277 15.6685 18.9707L12 21.0889L8.33154 18.9707C5.65966 17.4277 4 14.5527 4 11.4678V7.23145L11.6812 2.79688C11.8784 2.6836 12.1221 2.6836 12.3184 2.79688L20 7.23145V11.4678Z",
    fill: "currentColor"
  }), ___EmotionJSX("path", {
    d: "M15.3721 8L16.8271 9.37305L10.7939 15.7647L7.17285 11.9282L8.62793 10.5552L10.794 12.8506L15.3721 8Z",
    fill: "currentColor"
  }));
}